import { ObjectWithClientId } from "client/Misc/clientId";
import { ClientValidationErrorModel, IpAddressRange } from "../common";

export type FailedUploadResult = {
	success: false;
	createdTopFolder: any;
	error: string;
	isNamingConflict: boolean;
};

export type SuccessfulUploadResult = {
	success: true;
	uploadedFile: any | null;
	uploadedFileName: string | null;
	createdTopFolder: any | null;
};

export type UploadResult = FailedUploadResult | SuccessfulUploadResult;

export enum DocumentStoreType {
	SharePoint = 1,
	WebDav = 2,
	Bookmarks = 3
}

export const enum EditorModes {
	View = 1,
	Edit = 2,
	MobileView = 3,
	InteractivePreview = 4
}

export const enum WacVersion {
	Office365 = 0x01,
	OnPremises = 0x02
}

export type OpenWacModel = {
	url: string;
	editorMode: EditorModes;
	version: WacVersion;
};

export type OpenInNewWorkspaceTabModel = {
	openWacModel: OpenWacModel;
	fileName: string;
};

export enum NewDocumentType {
	Word = 0x01,
	Excel = 0x02,
	PowerPoint = 0x03,
	OneNote = 0x04
}


export type DocumentActionConditionalAccessSettingsSaveModel = {
	restrictIp: boolean;
	whitelistIpRanges: ObjectWithClientId<IpAddressRange>[];
	blacklistIpRanges: ObjectWithClientId<IpAddressRange>[];
};

export type DocumentActionConditionalAccessSettingsModel = {
	whitelistIpRanges: string[];
	blacklistIpRanges: string[];
};

export const enum OfficeDocumentEditor {
	Local = 1,
	Online = 2
}

export type MoveSuccessResult = {
	kind: "success";
};

export type MoveFailedItem = {
	name: string;
	reason?: string | undefined;
};

export type MoveFailedCompletelyOrPartiallyResult = {
	kind: "failed";
	failedItems: readonly MoveFailedItem[];
};

export type MoveScheduledResult = {
	kind: "scheduled";
};

export type MoveHasTheSameDestinationResult = {
	kind: "same-destination";
};

export type MoveResult = MoveSuccessResult |
	MoveFailedCompletelyOrPartiallyResult |
	MoveScheduledResult |
	MoveHasTheSameDestinationResult;

export type CopySuccessResult = {
	kind: "success";
};

export type CopyFailedResult = {
	kind: "failed";
	errors: readonly ClientValidationErrorModel[];
};

export type CopyScheduled = {
	kind: "scheduled";
};

export type CopyResult = CopySuccessResult | CopyFailedResult | CopyScheduled;

export enum NameConflictResolutionKind {
	Skip = 1,
	Replace = 2,
	KeepBoth = 3
};